export const landing2 = {
  navigation: {
    home: "Főoldal",
    features: "Hogyan?",
    pricingAndExperiences: "Mit?",
    about: "Ki?",
    contact: "Kapcsolat",
    login: "Bejelentkezés",
    benefits: "Előnyök",
    getStarted: "Kezdd el",
    pricing: "Árazás",
  },
  languages: [
    { code: 'HU', name: 'Magyar', flag: '🇭🇺' },
    { code: 'EN', name: 'English', flag: '🇬🇧' },
    { code: 'DE', name: 'Deutsch', flag: '🇩🇪' },
    { code: 'FR', name: 'Français', flag: '🇫🇷' },
    { code: 'IT', name: 'Italiano', flag: '🇮🇹' },
    { code: 'ES', name: 'Español', flag: '🇪🇸' },
    { code: 'NL', name: 'Nederlands', flag: '🇳🇱' },
    { code: 'PL', name: 'Polski', flag: '🇵🇱' }
  ],
  hero: {
    title: "AI asszisztens",
    dynamicWords: ["generál tartalmakat", "optimalizál", "közösséget épít", "automatizál", "dolgozik helyetted", "növeli bevételed"],
    subtitle: "miközben te alkotsz",
    description: "Egy intelligens partner, aki segíti az online jelenlétedet, miközben te arra koncentrálsz, amiben a legjobb vagy.",
    cta: "Kezdd el most"
  },
  steps: {
    mainTitle: "Gyors, egyszerű, biztonságos",
    subtitle: "",
    aiTitle: "Így működik a gyakorlatban",
    aiSteps: [
      "Ingyenes regisztráció",
      "Azonosítsd magad", 
      "Az AI mindenben segít, hogy hatékonyabban dolgozz"
    ],
    focusTitle: "Az AI asszisztens 24/7 dolgozik helyetted",
    tryButton: "Próbáld ki most",
    items: [
      {
        title: "Automatikus tartalom",
        description: "Generál neked posztokat és weboldalakat."
      },
      {
        title: "Elemzések",
        description: "Figyeli és optimalizálja az eladásokat."
      },
      {
        title: "Közösségépítés",
        description: "Segít megérteni és aktiválni a követőidet."
      },
      {
        title: "Automatizmusok",
        description: "Beállítja a termékeidet, kezel minden fizetést helyetted."
      }
    ]
  },
  whatToSell: {
    title: "Mit tudsz értékesíteni?",
    subtitle: "Bármilyen digitális terméket vagy szolgáltatást",
    digital: "Digitális termékek",
    services: "Szolgáltatások és élmények", 
    digitalItems: [
      {
        title: "Videótartalom",
        description: "Oktatóanyagok, vlogok, exkluzív felvételek"
      },
      {
        title: "Digitális könyvek", 
        description: "E-bookok, útmutatók, receptgyűjtemények"
      },
      {
        title: "Képek és grafika",
        description: "Stock fotók, matricák, GIF-ek, design elemek"
      },
      {
        title: "Audioanyagok",
        description: "Zenék, podcastok, hangoskönyvek, meditációk"
      }
    ],
    experiences: [
      {
        title: "Csoportos találkozók",
        description: "Szervezz interaktív eseményeket, workshopokat vagy csoportos konzultációkat a közösséged tagjaival – akár online videóhívásban, akár személyesen."
      },
      {
        title: "Egyéni konzultációk",
        description: "Személyre szabott egy-az-egyben tanácsadás és mentoring – online videóhívásban vagy személyes találkozó formájában, a téma szakértőjeként."
      },
      {
        title: "Workshopok",
        description: "Interaktív oktatási élmények élő bemutatókkal és gyakorlatokkal kis csoportok számára – online vagy offline helyszínen."
      },
      {
        title: "Jegyértékesítés",
        description: "Adj el jegyeket koncertjeidre, fitnesz óráidra, előadásaidra vagy bármilyen eseményedre – minden egy helyen, egyszerűen."
      },
      {
        title: "Exkluzív tartalmak",
        description: "Speciális hozzáférés extra anyagokhoz, korai kiadásokhoz vagy zárt közösségi tartalmakhoz."
      },
      {
        title: "Személyes videóüzenetek",
        description: "Küldj egyedi, személyre szabott videókat a követőidnek – legyen szó születésnapi köszöntőről, inspiráló üzenetről vagy gyors videós tanácsról egy adott témában."
      },
      {
        title: "Privát üzenetek",
        description: "Írásban válaszolj a követőid kérdéseire – legyen szó tanácsról, megerősítésről vagy akár inspirációról. Tökéletes választás, ha értékes támogatást adnál, de gyors és hatékony formában."
      }
    ]
  },
  personas: {
    title: "Egy platform minden tartalomgyártónak",
    subtitle: "Néhány példa arra, hogyan használják mások a Bespire-t",
    examplesLabel: "Mit kapsz:",
    cta: "Nézd meg, mit kínálhat neked",
    items: [
      {
        title: "Tartalomgyártók",
        description: "Te csak alkoss – mi generáljuk a weboldalad, elemezzük a követőid reakcióit, és automatikusan kezeljük a fizetéseket.",
        examples: ["Mit posztoljak?", "Mikor posztoljak?", "Teljes weboldal", "Előfizetés"]
      },
      {
        title: "Sminkesek",
        description: "Mutasd meg előtte-utána munkáidat profi weboldalon! Mi gondoskodunk a foglalásokról, míg te a szépségre fókuszálsz.",
        examples: ["Indexkép / Thumbnail", "Landing page", "Brand együttműködések", "Analitika"]
      },
      {
        title: "Egészségügyi szakértők",
        description: "Bizalmat építő szakértői jelenlét online – weboldal, tartalmak és időpontkezelés teljesen automatizálva.",
        examples: ["Mit posztoljak?", "Teljes weboldal", "Social platform trendek", "Analitika"]
      },
      {
        title: "Személyi edzők",
        description: "Coaching programjaid értékesítése sosem volt ennyire egyszerű! Motiválj, inspirálj, és mi kezeljük a többit.",
        examples: ["Mikor posztoljak?", "Giveaway/Challenge", "Előfizetés", "Repurposing"]
      },
      {
        title: "Zenészek",
        description: "Koncertjeid, merchandising-ed, egyedi dalaid – minden egy helyen! Építs közösséget, mi támogatjuk a növekedést.",
        examples: ["Indexkép / Thumbnail", "Brand együttműködések", "Monetizáció & ajánlatok", "Social platform trendek"]
      },
      {
        title: "Séfek",
        description: "Oszd meg receptjeidet és főzőtudásodat! Az AI elemzi, mi érdekel leginkább, te pedig ezt taníthatod tovább.",
        examples: ["Mit posztoljak?", "Indexkép / Thumbnail", "Landing page", "Repurposing"]
      },
      {
        title: "Tanárok",
        description: "Oktatj hatékonyabban! Készíts tananyagot, elemezd diákjaid haladását, automatizáld a beiratkozást.",
        examples: ["Teljes weboldal", "Mit posztoljak?", "Előfizetés", "Analitika"]
      },
      {
        title: "Pszichológusok",
        description: "Segíts másoknak nyugodt háttérrel – időpontok, számlázás, kommunikáció mind automatizálva.",
        examples: ["Landing page", "Social platform trendek", "Mikor posztoljak?", "Analitika"]
      },
      {
        title: "Üzleti tanácsadók",
        description: "Fejleszd ügyfeleid üzletét, mi fejlesztjük a tiédet! Lead kezelés, mentoring értékesítés – gördülékenyen.",
        examples: ["Teljes weboldal", "Brand együttműködések", "Monetizáció & ajánlatok", "Analitika"]
      },
      {
        title: "Életmód tanácsadók",
        description: "Inspirálj, motiválj, változtass életeket! Építsd wellness birodalmad AI támogatással.",
        examples: ["Mit posztoljak?", "Giveaway/Challenge", "Előfizetés", "Social platform trendek"]
      },
      {
        title: "Gamerek",
        description: "Stream, közösség, exkluzív tartalom – egy platformon! Keresd meg rajongóid, és értékesíts nekik könnyedén.",
        examples: ["Indexkép / Thumbnail", "Mikor posztoljak?", "Repurposing", "Előfizetés"]
      }
    ]
  },
  benefits: {
    title: "Miért használj AI asszisztenst?",
    items: [
      {
        title: "Időt spórolsz",
        description: "Az AI megcsinálja, amit eddig manuálisan kellett. Tartalomkészítés, ütemezés, optimalizálás – mind automatikusan."
      },
      {
        title: "Több bevételt hozol",
        description: "Minden folyamat optimalizálva van a konverzióra. Az AI figyeli a trendeket és automatikusan javít a teljesítményen."
      },
      {
        title: "Egyszerű lesz minden",
        description: "Nincs külön weboldal-, fizetés- és számlázórendszer – minden egyben. Egy helyen kezelhetsz mindent egyszerűen."
      },
      {
        title: "Fókuszálhatsz a lényegre",
        description: "Te a tartalomra és a közönségedre koncentrálhatsz, miközben az AI elvégzi a háttérmunkát és az adminisztrációt."
      }
    ]
  },
  stats: {
    title: "Csatlakozz",
    subtitle: "Értékesítsd termékeidet és szolgáltatásaidat közvetlenül a követőidnek",
    items: [
      { value: "Legyen", label: "a tied a következő sikertörténet" },
      { value: "Építsd fel", label: "creator vállalkozásod még ma" },
      { value: "Találd meg", label: "az utad a sikerhez" },
      { value: "Realizáld", label: "álmaidat velünk" }
    ]
  },
  signup: {
    title: "Bespire kreatív platform",
    subtitle: "Csatlakozz hozzánk és formáld velünk a jövőt. Elsőként regisztrált alkotóink különleges előnyökben részesülnek.",
    cta: "Kezdd el most",
  },
  faq: {
    title: "Gyakran Ismételt Kérdések",
    questions: [
      {
        question: "Mennyibe kerül a szolgáltatás? Van ingyenes próba?",
        answer: "Az oldal generálása és kipróbálása teljesen ingyenes, regisztráció nélkül. Élesítés után a platform jutalék alapú árazást használ, rejtett díjak nélkül. A korai felhasználók különleges kedvezményekben részesülnek."
      },
      {
        question: "Támogatja‑e a platform a nemzetközi elérést és fizetéseket?",
        answer: "Igen. A Bespire többnyelvű felülettel, automatikus számlázási/adózási megfelelőséggel és globális fizetési megoldásokkal segíti a kreatorokat, így bárhonnan értékesítheted a tartalmaidat."
      },
      {
        question: "Milyen típusú termékeket adhatok el?",
        answer: "Digitális termékeket, mint videók, e-könyvek, hanganyagok, képek, valamint szolgáltatásokat, mint személyes konzultációk, workshopok, online találkozók és személyre szabott videóüzenetek."
      },
      {
        question: "Milyen gyorsan tudok elindulni az értékesítéssel?",
        answer: "A weboldalad percek alatt elkészül! Az AI asszisztensünk segít mindent gyorsan beállítani, és az oldal élesítése után azonnal elkezdhetsz értékesíteni."
      },
      {
        question: "Szükséges technikai tudás a platform használatához?",
        answer: "Semmilyen technikai tudás nem szükséges! Az AI asszisztensünk chaten keresztül végigvezet az egész folyamaton. Csak válaszolj néhány kérdésre, és az AI automatikusan létrehozza a weboldaladat."
      },
      {
        question: "Hogyan működik a fizetésfeldolgozás?",
        answer: "A Bespire automatikusan kezeli az összes fizetésfeldolgozást, számlázást és adó megfelelőséget. A vásárlóid biztonságosan fizethetnek bankkártyával, te pedig rendszeresen megkapod a bevételeidet."
      },
      {
        question: "Testreszabhatom a weboldalam dizájnját?",
        answer: "Természetesen! Teljes mértékben testreszabhatod a weboldaladat - színek, logó, tartalom, sőt saját domain nevet is használhatsz. Az AI asszisztens egyszerű chat parancsokon keresztül segít mindent személyre szabni."
      },
      {
        question: "Hogyan kérhetek segítséget?",
        answer: "24/7 ügyfélszolgálat áll rendelkezésedre. Elérsz minket a kapcsolatfelvételi űrlapon, e‑mailen vagy élő chaten keresztül – minden kérdésre gyorsan válaszolunk."
      }
    ],
  },
  contact: {
    title: "Kérdésed van?",
    subtitle: "Írj nekünk bizalommal!",
    responseTime: "Ügyfélszolgálatunk 24 órán belül válaszol",
    email: "info@bespire.io"
  },
  animatedChat: {
    aiName: "Bespire AI Assistant",
    status: "Online",
    mostActive: "Most aktív",
    welcome: "Szia! Segítek létrehozni a tökéletes kreator weboldaladat. Meséld el, milyen tartalmat alkotsz!",
    userResponse1: "Zenei producer vagyok, elektronikus zenét készítek és online kurzusokat tartok",
    aiResponse1: "Fantasztikus! Elektronikus zene és oktatás... Milyen stílusú designt szeretnél? Modern-minimál vagy inkább vibráló-energikus?",
    userResponse2: "Vibráló és energikus! Sötét háttér neon akcentekkel",
    aiResponse2: "Tökéletes! Generálom az oldalad cyberpunk stílusban... Perceken belül kész lesz!",
    userLabel: "Te",
  },
  paymentMethods: {
    title: "Vásárlóid így tudnak neked fizetni",
    subtitle: "Minden fizetési mód automatikusan elérhető lesz a te web oldaladon"
  },
  affiliate: {
    badge: "Extra bevétel",
    title: "Ajánlói Program",
    description: "Szívesen ajánlanád a Bespire-t másoknak? Oszd meg a platformot és szerezz jutalékot minden sikeres regisztrációért.",
    partnerProgram: "Partner Program",
    affiliateProgram: "Ajánlói program", 
    aboutUs: "Rólunk",
    legal: "Jogi",
    newsletterSuccess: "Köszönjük a feliratkozást! Hamarosan küldünk hírleveleket.",
    ctaTitle: "Kezdj el keresni most",
    ctaDescription: "Egy egyszerű link megosztásával már indulhat is a bevétel",
    ctaButton: "Program részletei"
  },
  footer: {
    support: "Támogatás",
    newsletter: "Hírlevelünk",
    newsletterDescription: "Legyél az elsők között, akik értesülnek az új funkciókról és lehetőségekről.",
    emailPlaceholder: "E-mail címed",
    subscribe: "Feliratkozás",
    privacy: "Adatvédelem",
    terms: "Felhasználási feltételek",
    copyright: "© 2025 Bespire. Minden jog fenntartva.",
    madeWithLove: "Készítve ❤️-vel alkotóknak",
    systemStatus: "Minden rendszer működik",
    privacyAlert: "Adatvédelmi szabályzat hamarosan elérhető!",
    termsAlert: "Felhasználási feltételek hamarosan elérhetők!"
  }
};